import packageJson from '../../package.json';

export const environment = {
  production: false,
  API_URL_ANZ: 'https://api.staging.siteconnect.io/api/',
  API_URL_UK: 'https://api.uk.staging.siteconnect.io/api/',
  ENV_AS_TEXT: 'SiteConnect-Staging',
  APP_NAME: 'SiteConnect Kiosk',
  AES_STORAGE_KEY: '!w5ZS*0=J\'e6px]o/lUXO_^ku#9EfF',
  SENTRY_DSN: 'https://47148999ab2d74d70235ba4738dcd01b@o4509041843699712.ingest.us.sentry.io/4509149958504448',
  SENTRY_ENVIRONMENT: 'staging',
  SENTRY_RELEASE: 'siteconnect-kiosk@'+packageJson.version,
  SENTRY_TRACES_SAMPLE_RATE: 0.1,
  SENTRY_REPLAYS_SESSION_SAMPLE_RATE: 0.1,
  SENTRY_NATIVE_REPLAYS_SESSION_SAMPLE_RATE: 0.0,
  SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE: 0.1,
  IPAPI_TOKEN: '53925c3b520983'
};
